module.exports = __webpack_public_path__ + "img/logout.408bc926.svg";